<template>
  <v-layout column>
    <v-flex xs12>
      <v-data-iterator
        :items="items"
        :items-per-page.sync="itemsPerPage"
        :page="page"
        :search="search"
        :sort-by="sortBy.toLowerCase()"
        :sort-desc="sortDesc"
        :custom-sort="customSort"
        hide-default-footer
      >
        <template v-slot:header>
          <v-toolbar dark color="blue darken-3" class="mb-1">
            <v-layout row wrap>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    prepend-inner-icon="fa-search"
                    label="Search"
                  ></v-text-field>
                </v-col>
                <template v-if="$vuetify.breakpoint.mdAndUp">
                  <v-col>
                    <v-select
                      v-model="sortBy"
                      flat
                      solo-inverted
                      hide-details
                      :items="keys"
                      prepend-inner-icon="fa-search"
                      label="Sort by"
                    ></v-select>
                  </v-col>
                  <v-col>
                    <v-btn-toggle v-model="sortDesc" mandatory>
                      <v-btn icon depressed color="blue" :value="false">
                        <v-icon>fa-arrow-up</v-icon>
                      </v-btn>
                      <v-btn icon depressed color="blue" :value="true">
                        <v-icon>fa-arrow-down</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </template>
              </v-row>
            </v-layout>
          </v-toolbar>
        </template>

        <template v-slot:default="props">
          <v-layout wrap>
            <v-row>
              <v-col>
                <v-list>
                  <v-list-item
                    v-for="article in props.items.filter(i=>i.lang==='de')"
                    :key="article.id"
                    @click="modifyArticle(article.id)"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        v-bind:class="{ 'light-green--text ': article.state==='PUBLISHED', 
                        'grey--text': article.state==='DELETED',
                        'orange--text ': article.state==='UNPUBLISHED'}"
                      >{{article.shortid}} - {{article.title}}</v-list-item-title>
                      <v-list-item-subtitle>{{new Date(article.time).toLocaleString()}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-avatar>
                      <v-btn
                        small
                        color="error"
                        icon
                        @click.stop="deleteArticleId=article.id;deleteDialog=true"
                      >
                        <v-icon small>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-avatar>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col>
                <v-list>
                  <v-list-item
                    v-for="article in props.items.filter(i=>i.lang==='fr')"
                    :key="article.id"
                    @click="modifyArticle(article.id)"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        v-bind:class="{ 'light-green--text ': article.state==='PUBLISHED', 
                        'grey--text': article.state==='DELETED',
                        'orange--text ': article.state==='UNPUBLISHED'}"
                      >{{article.shortid}} - {{article.title}}</v-list-item-title>
                      <v-list-item-subtitle>{{new Date(article.time).toLocaleString()}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-avatar>
                      <v-btn
                        small
                        color="error"
                        icon
                        @click.stop="deleteArticleId=article.id;deleteDialog=true"
                      >
                        <v-icon small>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-avatar>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col>
                <v-list>
                  <v-list-item
                    v-for="article in props.items.filter(i=>i.lang==='it')"
                    :key="article.id"
                    @click="modifyArticle(article.id)"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        v-bind:class="{ 'light-green--text ': article.state==='PUBLISHED', 
                        'grey--text': article.state==='DELETED',
                        'orange--text ': article.state==='UNPUBLISHED'}"
                      >{{article.shortid}} - {{article.title}}</v-list-item-title>
                      <v-list-item-subtitle>{{new Date(article.time).toLocaleString()}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-avatar>
                      <v-btn
                        small
                        color="error"
                        icon
                        @click.stop="deleteArticleId=article.id;deleteDialog=true"
                      >
                        <v-icon small>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-avatar>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-layout>
        </template>

        <template v-slot:footer>
          <v-layout mt-2 wrap align-center justify-center>
            <span class="grey--text">Items per page</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark text color="primary" class="ml-2" v-on="on">
                  {{ itemsPerPage }}
                  <v-icon>fa-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-spacer></v-spacer>

            <span class="mr-4 grey--text">Page {{ page }} of {{ numberOfPages }}</span>
            <v-btn small icon dark color="blue darken-3" class="mr-1" @click="formerPage">
              <v-icon>fa-chevron-left</v-icon>
            </v-btn>
            <v-btn small icon dark color="blue darken-3" class="ml-1" @click="nextPage">
              <v-icon>fa-chevron-right</v-icon>
            </v-btn>
          </v-layout>
        </template>
      </v-data-iterator>
    </v-flex>
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline" primary-title>Delete article</v-card-title>
        <v-card-text>Do you want really to delete the article definitively?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="deleteDialog=false; deleteArticleId=-1">Cancel</v-btn>
          <v-btn color="error" text @click="deleteArticle">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      itemsPerPageArray: [10, 20, -1],
      search: "",
      filter: {},
      sortDesc: true,
      page: 1,
      itemsPerPage: -1,
      sortBy: "shortid",
      keys: ["time", "title", "shortid"],
      deleteDialog: false,
      deleteArticleId: -1
    };
  },
  computed: {
    items: function() {
      let articles = this.$store.getters.articles;
      articles.forEach(a => {
        a.time = Date.parse(`${a.pubDate}T${a.pubTime}:00`);
      });
      return articles;
    },
    numberOfPages() {
      return Math.ceil(this.$store.getters.articles.length / this.itemsPerPage);
    }
  },
  mounted() {},
  methods: {
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    modifyArticle: function(id) {
      this.$router.push({ name: "Article", params: { id } });
    },
    deleteArticle: function() {
      this.$store.dispatch("articles/delete", this.deleteArticleId);
      this.deleteArticleId = -1;
      this.deleteDialog = false;
    },
    customSort: function(items, index, isDesc) {
      items.sort((a, b) => {
        if (index == "time") {
          if (!isDesc[0]) {
            return new Date(a.time) < new Date(b.time) ? -1 : 1;
          } else {
            return new Date(b.time) < new Date(a.time) ? -1 : 1;
          }
        } else if (index == "shortid") {
          if (!isDesc[0]) {
            return a.shortid.localeCompare(b.shortid, undefined, {
              numeric: true,
              sensitivity: "base"
            });
          } else {
            return b.shortid.localeCompare(a.shortid, undefined, {
              numeric: true,
              sensitivity: "base"
            });
          }
        } else {
          if (!isDesc[0]) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    }
  }
};
</script>
